module.exports = __webpack_public_path__ + "img/wjdx.ac9edb2f.svg";